(function($){

    var initializeBlock = function( $block ) {

        //Get container data-set
        var dateValue = $block.data('date');

        //Convert to Safari support value
        dateValue =(dateValue.replace(/\s/, 'T')+'Z');

        var countDownDate = new Date(dateValue).getTime();

        // Update the count down every 1 second
        var x = setInterval(function() {

            // Get today's date and time
            var now = new Date().getTime();
            
            // Find the distance between now and the count down date
            var distance = countDownDate - now;
            
            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            
            $block.find('.countdown-days').html(days);
            $block.find('.countdown-hours').html(hours);
            $block.find('.countdown-minutes').html(minutes);
            $block.find('.countdown-seconds').html(seconds);
            $block.find('.countdown-container').addClass('active');

            /*
            //Vanilla
            $block.getElementsByClassName('countdown-days')[0].innerHTML = days;
            $block.getElementsByClassName('countdown-hours')[0].innerHTML = hours;
            $block.getElementsByClassName('countdown-minutes')[0].innerHTML = minutes;
            $block.getElementsByClassName('countdown-seconds')[0].innerHTML = seconds;
            */
            
            // If the count down is over, write some text 
            if (distance < 0) {
            clearInterval(x);
            $block.innerHTML = 'Expired';
            }
        }, 1000);
    };

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.wpk-block-countdown').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        //window.acf.addAction( 'render_block_preview/type=countdown', initializeBlock );
    }

})(jQuery);